import { useCallback } from 'react'

const findMissingFieldsInObject = (val, dataRow, dataKey) => {
  const entries = Object.entries(val)
  return entries.every(([key, value]) => {
    if (typeof value === 'object') {
      return findMissingFieldsInObject(value, dataRow, dataKey)
    }
    if (dataRow[key] === value) {
      return !dataRow[dataKey]?.toString()?.length ?? true
    }
    return false
  })
}

export const useGetRowMissingFields = (requiredColumns) => (
  useCallback((row) => {
    return requiredColumns.filter(c => {
      if (typeof c === 'object') {
        return Object.keys(c).some(k => (
          findMissingFieldsInObject(c, row, k)
        ))
      }

      return !row[c]?.toString()?.length
    })
  }, [requiredColumns])
)
